export default "__VITE_PUBLIC_ASSET__78aa017b__"